import { Action, Reducer } from "redux";
import { PartTypeState, PartTypeTypes, PartTypeActionTypes } from "./partTypeTypes";

export const INITIAL_STATE: PartTypeState = {
	partType: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const partTypeReducer: Reducer<PartTypeState> = (state: PartTypeState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as PartTypeActionTypes;
	switch (actionTypes.type) {
		case PartTypeTypes.GET_PART_TYPE:
			return {
				...state,
				partType: { ...state.partType, isLoading: true },
			};
		case PartTypeTypes.GET_PART_TYPES_BY_SUPPLIER_MANUFACTURER:
			return {
				...state,
				partType: { ...state.partType, isLoading: true },
			};
		case PartTypeTypes.GET_PART_TYPES_BY_DIRECT_ASSIGN_CRITERIA:
			return {
				...state,
				partType: { ...state.partType, isLoading: true },
			};
		case PartTypeTypes.SAVE_PART_TYPE:
			return {
				...state,
				partType: {
					...state.partType,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case PartTypeTypes.RESET_REDUCER_PART_TYPE:
			return {
				...state,
				partType: INITIAL_STATE.partType,
			};
		default:
			return state;
	}
};

export default partTypeReducer;
